"use client";

import { useEffect } from "react";

/**
 * MSAL v5 redirect bridge page.
 *
 * The popup window opened by `loginPopup` lands here after the IdP completes
 * the OAuth flow. `broadcastResponseToMainFrame()` reads the auth response
 * from the URL (hash / query) and forwards it to the opener via
 *
 * IMPORTANT: this route must be excluded from any heavy provider tree, the
 * i18n locale prefix.
 * No need for localize the text here, since it's barely visible to the user.
 */
export default function AuthRedirectPage() {
  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const { broadcastResponseToMainFrame } =
          await import("@azure/msal-browser/redirect-bridge");
        if (cancelled) return;
        await broadcastResponseToMainFrame();
      } catch (error) {
        console.error("MSAL redirect bridge failed", error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return <p>Processing authentication…</p>;
}
